/*const cutoffText = document.querySelectorAll('.cutoff-text')
cutoffText.forEach(elem => {
  if(elem.textContent.length > 260)
    elem.outerHTML = elem.outerHTML + `<input class="expand-btn" type="checkbox">`
})*/
var maxLength = 160;
var ellipsis = '...';
document.addEventListener('DOMContentLoaded', function (){
    moreText();

    $('body').on('change', '.expand-btn', function(){
        if ($(this).is(':checked')) {
            $(this).prev('.cutoff-text').text($(this).prev('.cutoff-text').data('original'));
        }else{
            truncateText($(this).prev('.cutoff-text'));
        }
    });
});

window.moreText = function (){
    $('.cutoff-text').each(function(){
        if($(this).text().length > maxLength){
            $(this).attr('data-original', $(this).text());
            truncateText(this);
            if ($(this).parent().find('.expand-btn').length === 0){
                $(this).after('<input class="expand-btn" type="checkbox">');
            }
        }
    });
}

window.truncateText = function(elm){
    var trimmedText = $(elm).text().substring(0, maxLength - ellipsis.length);
    trimmedText += ellipsis;
    $(elm).text(trimmedText);
}
